import PropTypes from 'prop-types';

const sortComps = {
  asc: (a, b) => a > b,
  desc: (a, b) => a < b
};

export const valSortFn = (a, b, sortBy, order = 'asc') => {
  if (sortComps[order.toLowerCase()](a[sortBy], b[sortBy])) return 1;
  if (sortComps[order.toLowerCase()](b[sortBy], a[sortBy])) return -1;
  return 0;
};

export const lengthSortFn = (a, b, sortBy, order = 'asc') => {
  if (sortComps[order.toLowerCase()](a[sortBy].length, b[sortBy].length)) return 1;
  if (sortComps[order.toLowerCase()](b[sortBy].length, a[sortBy].length)) return -1;
  return 0;
};

export const strSortFn = (a, b, sortBy, order = 'asc') => {
  if (sortComps[order.toLowerCase()](a[sortBy]?.toLowerCase(), b[sortBy]?.toLowerCase())) return 1;
  if (sortComps[order.toLowerCase()](b[sortBy]?.toLowerCase(), a[sortBy]?.toLowerCase())) return -1;
  return 0;
};

export const supplierShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  properties: PropTypes.number,
  brand: PropTypes.string,
  domain: PropTypes.string,
  contactEmail: PropTypes.string,
  numAdmins: PropTypes.number,
  actionRequired: PropTypes.bool
});

export const customerShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  domain: PropTypes.string,
  contactEmail: PropTypes.string,
  numAdmins: PropTypes.number,
  bookings: PropTypes.number,
  isPending: PropTypes.bool,
  status: PropTypes.string
});

export const userShape = PropTypes.shape({
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  emailAddress: PropTypes.string,
  phone: PropTypes.string,
  company: PropTypes.string,
  position: PropTypes.string,
  dateJoined: PropTypes.string,
  lastLogin: PropTypes.string,
  currentOrgName: PropTypes.string,
  customers: PropTypes.arrayOf(customerShape),
  suppliers: PropTypes.arrayOf(supplierShape)
});

export const adminPropertyShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  status: PropTypes.string,
  lastUpdated: PropTypes.string,
  city: PropTypes.string,
  cardImage: PropTypes.string,
  type: PropTypes.string,
  slug: PropTypes.string
});

export const memberShape = PropTypes.shape({
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profilePicture: PropTypes.string,
  emailAddress: PropTypes.string,
  phone: PropTypes.string,
  isPrimaryContact: PropTypes.bool,
  userType: PropTypes.string,
  roles: PropTypes.string
});

export const featureFlagShape = PropTypes.shape({
  id: PropTypes.number,
  featureName: PropTypes.string,
  description: PropTypes.string,
  active: PropTypes.bool
});

export const featureFlagMappingShape=  PropTypes.shape({
  orgName: PropTypes.string,
  orgEmail: PropTypes.string,
  active: PropTypes.bool,
  featureId: PropTypes.number
})

export const NUM_PER_PAGE = {
  xs: [10, 20, 30],
  sm: [10, 20, 30],
  md: [10, 20, 30],
  lg: [9, 18, 27],
  xl: [9, 18, 27]
};

export const FILTER_RESOLVER = {
  ALL_PROPERTIES_VIEW: '',
  DRAFT_PROPERTIES: 'Draft',
  APPROVED_PROPERTIES: 'Approved',
  PUBLISHED_PROPERTIES: 'Published',
  ARCHIVED_PROPERTIES: 'Archived'
};

export const SORT_RESOLVER = {
  PROPERTY_NAME_SORT: 'propertyNameAsc',
  PROPERTY_NAME_SORT_DESC: 'propertyNameDesc',
  PROPERTY_UPDATE_SORT: 'recentlyUpdatedAsc',
  PROPERTY_UPDATE_SORT_DESC: 'recentlyUpdatedDesc',
  PROPERTY_LOCATION_SORT: 'cityAsc',
  PROPERTY_LOCATION_SORT_DESC: 'cityDesc'
};

export const SUPP_SORT_RESOLVER = {
  SUPPLIER_NAME_ASC: 'supplierNameAsc',
  SUPPLIER_NAME_DESC: 'supplierNameDesc',
  STATUS_ASC: 'statusAsc',
  STATUS_DESC: 'statusDesc',
  CONTACT_EMAIL_ASC: 'contactEmailAsc',
  CONTACT_EMAIL_DESC: 'contactEmailDesc',
  NUM_PROPERTIES_ASC: 'numPropertiesAsc',
  NUM_PROPERTIES_DESC: 'numPropertiesDesc'
};

export const connectionShape = PropTypes.shape({
  id: PropTypes.string,
  extSystem: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  hotelCode: PropTypes.string,
  chainCode: PropTypes.string,
  primaryRoomCode: PropTypes.bool,
  capabilities: PropTypes.string
});

export const approvalConfigShape = PropTypes.shape({
  id: PropTypes.number,
  createdOn: PropTypes.string,
  updatedOn: PropTypes.string,
  createdBy: PropTypes.string,
  createdFor: PropTypes.string
});

export const approvalShape = PropTypes.shape({
  id: PropTypes.number,
  status: PropTypes.string,
  bookingNumber: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  amount: PropTypes.string,
  createdAt: PropTypes.string,
  actionedBy: PropTypes.string,
  emailAddress: PropTypes.string,
  companyName: PropTypes.string,
  comments: PropTypes.string
});

export const APPROVAL_FILTER_RESOLVER = {
  ALL_APPROVAL_REQUESTS_VIEW: 'All',
  APPROVED_APPROVAL_REQUESTS: 'Approved',
  REJECTED_APPROVAL_REQUESTS: 'Rejected',
  PENDING_APPROVAL_REQUESTS: 'Pending',
  APPROVED_ACTIONED_APPROVAL_REQUESTS: 'ApprovedActioned',
  CANCELLED_APPROVAL_REQUESTS: 'Cancelled'
};

export const APPROVAL_SORT_RESOLVER = {
  APPROVAL_STATUS_SORT: 'statusAsc',
  APPROVAL_STATUS_SORT_DESC: 'statusDesc',
  APPROVAL_AMOUNT_SORT: 'amountAsc',
  APPROVAL_AMOUNT_SORT_DESC: 'amountDesc',
  APPROVAL_PENDING_DURATION_SORT: 'pendingDurationDesc',
  APPROVAL_PENDING_DURATION_SORT_DESC: 'pendingDurationAsc'
};
